(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
/* ORIGNIA LOGO REPLAY 10S */
(() => {
  const logos = [...document.querySelectorAll('.ob-animated-logo')];
  if (!logos.length) return;

  const reduced = window.matchMedia('(prefers-reduced-motion: reduce)');
  let replayTimer = null;

  const replay = () => {
    if (document.hidden || reduced.matches) return;

    logos.forEach((logo) => {
      logo.classList.remove('is-animating');
      void logo.offsetWidth;
      logo.classList.add('is-animating');
    });
  };

  const startReplay = () => {
    if (replayTimer) window.clearInterval(replayTimer);
    if (reduced.matches) return;
    replayTimer = window.setInterval(replay, 10000);
  };

  const onVisibility = () => {
    if (document.hidden) {
      if (replayTimer) window.clearInterval(replayTimer);
      replayTimer = null;
    } else {
      startReplay();
    }
  };

  reduced.addEventListener?.('change', startReplay);
  document.addEventListener('visibilitychange', onVisibility);
  startReplay();
})();

  class StickyHeader extends HTMLElement {
    constructor() {
      super();
      this.setHeaderHeight = this.setHeaderHeight.bind(this);
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.mobileMediaQuery = window.matchMedia('(max-width: 990px)');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      this.mobileMediaQuery.addEventListener('change', this.setHeaderHeight);

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearches = this.querySelectorAll('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.mobileMediaQuery.removeEventListener('change', this.setHeaderHeight);
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if ([...this.predictiveSearches].some((predictiveSearch) => predictiveSearch.isOpen)) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModals = this.searchModals || this.header.querySelectorAll('details-modal');
      this.searchModals.forEach((searchModal) => searchModal.close(false));
    }
  }

  // The account `open` event is composed but does not bubble, so listen during capture.
  // Anchor the dialog to the bottom of the account button itself. The header group can be
  // much taller than the button's row (for example, a top-left logo pushes the menu to a
  // second row), so anchoring to the section bottom drops the dialog too low.
  document.addEventListener(
    'open',
    (event) => {
      if (!(event.target instanceof HTMLElement) || !event.target.matches('shopify-account')) return;

      const bottom = Math.max(0, Math.round(event.target.getBoundingClientRect().bottom));
      event.target.style.setProperty('--account-dialog-top', `${bottom}px`);
    },
    true
  );

  customElements.define('sticky-header', StickyHeader);


  window.__origniaBeautyHeaderCleanup?.();
  const origniaHeader = document.querySelector('.ob-live-header');
  if (origniaHeader) {
    const origniaWrapper = origniaHeader.closest('.header-wrapper');
    const origniaLogo = origniaHeader.querySelector('.header__heading-link');
    const origniaReduced = window.matchMedia('(prefers-reduced-motion: reduce)');
    const origniaDesktop = window.matchMedia('(hover: hover) and (pointer: fine)');
    let origniaFrame = 0;
    let origniaResizeObserver;

    const origniaResetTilt = () => {
      origniaLogo?.style.removeProperty('--ob-rx');
      origniaLogo?.style.removeProperty('--ob-ry');
    };
    const origniaMeasure = () => {
      document.documentElement.style.setProperty('--ob-header-height', `${origniaHeader.getBoundingClientRect().height}px`);
    };
    const origniaSync = () => {
      const scrolled = window.scrollY > 24;
      origniaHeader.classList.toggle('ob-scrolled', scrolled);
      origniaWrapper?.classList.toggle('ob-scrolled', scrolled);
      origniaMeasure();
    };
    const origniaOnScroll = () => {
      if (origniaFrame) return;
      origniaFrame = requestAnimationFrame(() => {
        origniaSync();
        origniaFrame = 0;
      });
    };
    const origniaOnPointerMove = (event) => {
      if (!origniaLogo || origniaReduced.matches || !origniaDesktop.matches) return;
      const rect = origniaLogo.getBoundingClientRect();
      if (!rect.width || !rect.height) return;
      const x = (event.clientX - rect.left) / rect.width - 0.5;
      const y = (event.clientY - rect.top) / rect.height - 0.5;
      origniaLogo.style.setProperty('--ob-rx', `${(-y * 5).toFixed(2)}deg`);
      origniaLogo.style.setProperty('--ob-ry', `${(x * 7).toFixed(2)}deg`);
    };
    const origniaOnReducedChange = () => { if (origniaReduced.matches) origniaResetTilt(); };
    const origniaOnViewportChange = () => { origniaResetTilt(); origniaMeasure(); };

    origniaSync();
    window.addEventListener('scroll', origniaOnScroll, { passive: true });
    window.addEventListener('resize', origniaOnViewportChange, { passive: true });
    origniaLogo?.addEventListener('pointermove', origniaOnPointerMove);
    origniaLogo?.addEventListener('pointerleave', origniaResetTilt);
    origniaLogo?.addEventListener('pointercancel', origniaResetTilt);
    origniaReduced.addEventListener?.('change', origniaOnReducedChange);
    origniaDesktop.addEventListener?.('change', origniaOnViewportChange);
    if (window.ResizeObserver) {
      origniaResizeObserver = new ResizeObserver(origniaMeasure);
      origniaResizeObserver.observe(origniaHeader);
    }

    window.__origniaBeautyHeaderCleanup = () => {
      window.removeEventListener('scroll', origniaOnScroll);
      window.removeEventListener('resize', origniaOnViewportChange);
      origniaLogo?.removeEventListener('pointermove', origniaOnPointerMove);
      origniaLogo?.removeEventListener('pointerleave', origniaResetTilt);
      origniaLogo?.removeEventListener('pointercancel', origniaResetTilt);
      origniaReduced.removeEventListener?.('change', origniaOnReducedChange);
      origniaDesktop.removeEventListener?.('change', origniaOnViewportChange);
      origniaResizeObserver?.disconnect();
      if (origniaFrame) cancelAnimationFrame(origniaFrame);
      origniaWrapper?.classList.remove('ob-scrolled');
      origniaHeader.classList.remove('ob-scrolled');
    };
  }


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["orignia-3d-viewer"] && !Shopify.designMode) return;
  try {
    
(() => {
  const STORIES_BY_PRODUCT = {
    'creme-deodorante': [
      { min:300,max:60,kicker:'Bénéfice',title:'Fraîcheur au quotidien',text:'Une texture crème pensée pour apporter confort et sensation de fraîcheur.',side:'right',x:62,y:48 },
      { min:60,max:180,kicker:'Ingrédients clés',title:'Coco · Karité · Zinc',text:'Huile de coco et beurre de karité pour le confort, oxyde de zinc et argile blanche dans la formule.',side:'left',x:40,y:50 },
      { min:180,max:300,kicker:'Application',title:'Simple et rapide',text:'Appliquer une petite quantité sur des aisselles propres et sèches.',side:'right',x:60,y:54 }
    ],
    'creme-hydratante': [
      { min:300,max:60,kicker:'Bénéfice',title:'Hydratation & confort',text:'Une crème pensée pour apporter douceur, confort et hydratation au quotidien.',side:'right',x:62,y:48 },
      { min:60,max:180,kicker:'Texture',title:'Douce et enveloppante',text:'Une texture agréable qui accompagne simplement votre routine de soin.',side:'left',x:40,y:50 },
      { min:180,max:300,kicker:'Application',title:'Votre geste quotidien',text:'Appliquer une petite quantité sur une peau propre puis masser délicatement.',side:'right',x:60,y:54 }
    ],
    'gel-nettoyant': [
      { min:300,max:60,kicker:'Bénéfice',title:'Nettoie en douceur',text:'Une formule pensée pour nettoyer la peau tout en préservant une sensation de fraîcheur et de confort.',side:'right',x:62,y:48 },
      { min:60,max:180,kicker:'Formule',title:'Fraîcheur & pureté',text:'Un gel nettoyant conçu pour accompagner simplement votre routine quotidienne.',side:'left',x:40,y:50 },
      { min:180,max:300,kicker:'Application',title:'Votre geste quotidien',text:'Appliquer sur peau humide, masser délicatement puis rincer à l’eau claire.',side:'right',x:60,y:54 }
    ],
    'serum-vitamine-c-et-acide-hyaluronique': [
      { min:300,max:60,kicker:'Bénéfice',title:'Éclat & hydratation',text:'Un sérum léger pensé pour apporter éclat et hydratation à votre routine.',side:'right',x:62,y:48 },
      { min:60,max:180,kicker:'Actifs clés',title:'Vitamine C · Acide hyaluronique',text:'Deux actifs au cœur de la formule pour compléter votre routine de soin.',side:'left',x:40,y:50 },
      { min:180,max:300,kicker:'Application',title:'Quelques gouttes',text:'Appliquer quelques gouttes sur une peau propre puis masser délicatement.',side:'right',x:60,y:54 }
    ]
  };

  const normalizeDeg = (deg) => ((deg % 360) + 360) % 360;

  const findStory = (deg, stories) => {
    const a = normalizeDeg(deg);
    return stories.find((s) => {
      if (s.min <= s.max) return a >= s.min && a <= s.max;
      return a >= s.min || a <= s.max;
    }) || null;
  };

  const setup = (root) => {
    if (!root || root.dataset.obReady === 'true') return;
    root.dataset.obReady = 'true';

    const viewer = root.querySelector('model-viewer');
    if (!viewer) return;
    const stories = STORIES_BY_PRODUCT[root.dataset.productHandle] || [];

    viewer.setAttribute('camera-controls','');
    viewer.setAttribute('auto-rotate','');
    viewer.setAttribute('auto-rotate-delay','0');
    viewer.setAttribute('rotation-per-second','7deg');
    viewer.setAttribute('camera-orbit','0deg 86deg 122%');
    viewer.setAttribute('field-of-view','29deg');
    viewer.setAttribute('min-field-of-view','24deg');
    viewer.setAttribute('max-field-of-view','40deg');
    viewer.setAttribute('shadow-intensity','0');
    viewer.setAttribute('shadow-softness','1');
    viewer.setAttribute('exposure','1');
    viewer.setAttribute('interaction-prompt','auto');
    viewer.setAttribute('interaction-prompt-threshold','1800');
    viewer.setAttribute('disable-pan','');
    viewer.style.touchAction = 'pan-y';

    const storyRoot = root.querySelector('[data-ob-3d-story]');
    const kicker = root.querySelector('[data-ob-story-kicker]');
    const title = root.querySelector('[data-ob-story-title]');
    const text = root.querySelector('[data-ob-story-text]');

    let productTouched = false;
    let holdTimer = null;
    let startX = 0;
    let startY = 0;
    let moved = false;

    const hideStory = () => {
      if (storyRoot) storyRoot.classList.remove('is-visible');
    };

    const showCurrentStory = () => {
      if (!storyRoot || typeof viewer.getCameraOrbit !== 'function') return;
      const orbit = viewer.getCameraOrbit();
      const deg = normalizeDeg((orbit.theta || 0) * 180 / Math.PI);
      const story = findStory(deg, stories);
      if (!story) return hideStory();

      kicker.textContent = story.kicker;
      title.textContent = story.title;
      text.textContent = story.text;
      storyRoot.dataset.side = story.side;
      storyRoot.style.setProperty('--story-x', story.x + '%');
      storyRoot.style.setProperty('--story-y', story.y + '%');
      storyRoot.classList.add('is-visible');
    };

    const clearHold = () => {
      if (holdTimer) window.clearTimeout(holdTimer);
      holdTimer = null;
    };

    const scheduleStory = (delay = 650) => {
      clearHold();
      if (root.dataset.obStory !== 'true') return;
      holdTimer = window.setTimeout(() => {
        if (productTouched) {
          moved = false;
          showCurrentStory();
        }
      }, delay);
    };

    viewer.addEventListener('pointerdown', (event) => {
      productTouched = true;
      moved = false;
      startX = event.clientX;
      startY = event.clientY;
      viewer.removeAttribute('auto-rotate');
      hideStory();
      scheduleStory(700);
    });

    viewer.addEventListener('pointermove', (event) => {
      if (!productTouched) return;

      const dx = Math.abs(event.clientX - startX);
      const dy = Math.abs(event.clientY - startY);

      if (dx > 6 || dy > 6) {
        moved = true;
        hideStory();
        clearHold();

        startX = event.clientX;
        startY = event.clientY;

        window.clearTimeout(viewer.__obHoldAfterMove);
        viewer.__obHoldAfterMove = window.setTimeout(() => {
          if (productTouched) scheduleStory(500);
        }, 120);
      }
    });

    const resumeImmediately = () => {
      clearHold();
      window.clearTimeout(viewer.__obHoldAfterMove);
      hideStory();
      if (!productTouched) return;
      viewer.setAttribute('auto-rotate','');
      productTouched = false;
      moved = false;
    };

    viewer.addEventListener('pointerup', resumeImmediately);
    viewer.addEventListener('pointercancel', resumeImmediately);


  };

  const initAll = () => {
    document.querySelectorAll('[data-ob-3d-viewer]').forEach(setup);
  };

  initAll();
  document.addEventListener('shopify:section:load', initAll);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["orignia-actifs"] && !Shopify.designMode) return;
  try {
    
(() => {
  const init = (root) => {
    if (!root || root.dataset.obReady === 'true') return;
    root.dataset.obReady = 'true';

    const viewport = root.querySelector('[data-ob-actifs-viewport]');
    const slides = [...root.querySelectorAll('.ob-actifs__slide')];
    const dots = [...root.querySelectorAll('.ob-actifs__dot')];
    if (!viewport || !slides.length) return;

    let userTouched = false;
    const markTouched = () => {
      userTouched = true;
      viewport.classList.remove('is-hinting');
    };

    viewport.addEventListener('pointerdown', markTouched, { passive:true });
    viewport.addEventListener('touchstart', markTouched, { passive:true });
    viewport.addEventListener('wheel', markTouched, { passive:true });

    let ticking = false;
    const syncDots = () => {
      if (!dots.length) return;
      const rect = viewport.getBoundingClientRect();
      const center = rect.left + rect.width / 2;
      let best = 0;
      let bestDistance = Infinity;

      slides.forEach((slide, index) => {
        const r = slide.getBoundingClientRect();
        const d = Math.abs((r.left + r.width / 2) - center);
        if (d < bestDistance) {
          bestDistance = d;
          best = index;
        }
      });

      dots.forEach((dot, index) => dot.classList.toggle('is-active', index === best));
      ticking = false;
    };

    viewport.addEventListener('scroll', () => {
      if (ticking) return;
      ticking = true;
      requestAnimationFrame(syncDots);
    }, { passive:true });

    const hint = () => {
      if (userTouched || viewport.scrollWidth <= viewport.clientWidth) return;
      const amount = Math.min(slides[0].getBoundingClientRect().width * .22, 84);
      viewport.classList.add('is-hinting');
      viewport.scrollTo({ left: amount, behavior:'smooth' });
      window.setTimeout(() => viewport.classList.remove('is-hinting'), 900);
    };

    if ('IntersectionObserver' in window) {
      const observer = new IntersectionObserver((entries) => {
        if (!entries.some(entry => entry.isIntersecting)) return;
        observer.disconnect();
        window.setTimeout(hint, 280);
      }, { threshold:.32 });
      observer.observe(root);
    } else {
      window.setTimeout(hint, 320);
    }
  };

  document.querySelectorAll('[data-ob-actifs]').forEach(init);
  document.addEventListener('shopify:section:load', (event) => {
    init(event.target.querySelector?.('[data-ob-actifs]'));
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["orignia-brand-character"] && !Shopify.designMode) return;
  try {
    
(() => {
  const IDLE = 'ORIGNIA_IDLE_01';
  const WELCOME = 'ORIGNIA_WELCOME_01';
  const PRESENT = 'ORIGNIA_PRESENT_01';

  const init = (root) => {
    if (!root || root.dataset.obCharacterReady === 'true') return;
    root.dataset.obCharacterReady = 'true';

    const viewer = root.querySelector('[data-ob-character-model]');
    const present = root.querySelector('[data-ob-character-present]');
    const modelUrl = root.dataset.modelUrl;
    if (!viewer || !modelUrl) return;

    let loaded = false;
    let timer = 0;

    const clearTimer = () => {
      if (timer) window.clearTimeout(timer);
      timer = 0;
    };

    const play = (name, duration, returnToIdle = true) => {
      if (!loaded || document.documentElement.classList.contains('no-js')) return;
      clearTimer();
      viewer.pause?.();
      viewer.animationName = name;
      viewer.currentTime = 0;
      viewer.play?.();
      if (returnToIdle && duration) {
        timer = window.setTimeout(() => {
          viewer.pause?.();
          viewer.animationName = IDLE;
          viewer.currentTime = 0;
          viewer.play?.();
        }, duration);
      }
    };

    const loadModel = () => {
      if (viewer.src) return;

      const attachModel = () => {
        if (viewer.src) return;
        viewer.src = modelUrl;
      };

      if (customElements.get('model-viewer')) {
        attachModel();
        return;
      }

      let script = document.querySelector('script[data-ob-model-viewer-loader]');
      if (!script) {
        script = document.createElement('script');
        script.type = 'module';
        script.src = 'https://unpkg.com/@google/model-viewer@4.3.1/dist/model-viewer.min.js';
        script.dataset.obModelViewerLoader = 'true';
        document.head.appendChild(script);
      }

      customElements.whenDefined('model-viewer').then(attachModel).catch(() => {
        root.classList.add('is-error');
      });
    };

    viewer.addEventListener('load', () => {
      loaded = true;
      root.classList.add('is-ready');
      if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
        viewer.animationName = IDLE;
        viewer.currentTime = 0;
        return;
      }
      play(WELCOME, 2000, true);
    }, { once:true });

    if ('IntersectionObserver' in window) {
      const observer = new IntersectionObserver((entries) => {
        if (entries.some((entry) => entry.isIntersecting)) {
          loadModel();
          observer.disconnect();
        }
      }, { rootMargin:'100px 0px' });
      observer.observe(root);
    } else {
      loadModel();
    }

    if (present) {
      const showPresent = () => play(PRESENT, 2000, true);
      present.addEventListener('pointerenter', showPresent);
      present.addEventListener('focus', showPresent);
    }
  };

  const initAll = () => document.querySelectorAll('[data-ob-character]').forEach(init);
  initAll();
  document.addEventListener('shopify:section:load', initAll);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["orignia-brand-values"] && !Shopify.designMode) return;
  try {
    
(() => {
  const init = (root) => {
    if (!root || root.dataset.obReady === 'true') return;
    root.dataset.obReady = 'true';

    const viewport = root.querySelector('[data-ob-values-viewport]');
    const progress = root.querySelector('[data-ob-values-progress]');
    if (!viewport) return;

    const syncProgress = () => {
      if (!progress) return;
      const max = viewport.scrollWidth - viewport.clientWidth;
      const ratio = max > 0 ? viewport.scrollLeft / max : 0;
      progress.style.transform = `translateX(${ratio * 300}%)`;
    };

    viewport.addEventListener('scroll', syncProgress, { passive:true });
    syncProgress();
  };

  document.querySelectorAll('[data-ob-brand-values]').forEach(init);
  document.addEventListener('shopify:section:load', (event) => {
    init(event.target.querySelector?.('[data-ob-brand-values]'));
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["orignia-collection-grid"] && !Shopify.designMode) return;
  try {
    
(() => {
  const init = (root) => {
    if (!root || root.dataset.obCollectionReady === 'true') return;
    root.dataset.obCollectionReady = 'true';

    const cards = [...root.querySelectorAll('[data-ob-product-card]')];
    const buttons = [...root.querySelectorAll('[data-ob-filter]')];
    const visibleCount = root.querySelector('[data-ob-visible-count]');
    const noResults = root.querySelector('[data-ob-no-results]');

    const counts = cards.reduce((acc, card) => {
      const category = card.dataset.category || 'all';
      acc.all = (acc.all || 0) + 1;
      acc[category] = (acc[category] || 0) + 1;
      return acc;
    }, {});

    root.querySelectorAll('[data-ob-count]').forEach((node) => {
      const key = node.dataset.obCount;
      node.textContent = counts[key] || 0;
      if (key !== 'all' && !counts[key]) {
        const button = node.closest('[data-ob-filter]');
        if (button) button.hidden = true;
      }
    });

    const apply = (filter) => {
      let visible = 0;
      cards.forEach((card) => {
        const show = filter === 'all' || card.dataset.category === filter;
        card.hidden = !show;
        if (show) visible += 1;
      });

      buttons.forEach((button) => {
        const active = button.dataset.obFilter === filter;
        button.classList.toggle('is-active', active);
        button.setAttribute('aria-pressed', active ? 'true' : 'false');
      });

      if (visibleCount) visibleCount.textContent = visible;
      if (noResults) noResults.hidden = visible !== 0;
    };

    buttons.forEach((button) => {
      button.addEventListener('click', () => apply(button.dataset.obFilter || 'all'));
    });

    apply('all');
  };

  document.querySelectorAll('[data-ob-collection-grid]').forEach(init);
  document.addEventListener('shopify:section:load', (event) => {
    init(event.target.querySelector?.('[data-ob-collection-grid]'));
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["orignia-expert"] && !Shopify.designMode) return;
  try {
    
(() => {
  const init = (root) => {
    if (!root || root.dataset.obReady === 'true') return;
    root.dataset.obReady = 'true';

    const media = root.querySelector('[data-ob-expert-media]');
    const video = media?.querySelector('video');
    const play = root.querySelector('[data-ob-expert-play]');
    if (!media || !video || !play) return;

    play.addEventListener('click', () => {
      video.controls = true;
      video.play().then(() => media.classList.add('is-playing')).catch(() => {});
    });

    video.addEventListener('ended', () => {
      media.classList.remove('is-playing');
      video.controls = false;
    });
  };

  document.querySelectorAll('[data-ob-expert]').forEach(init);
  document.addEventListener('shopify:section:load', (event) => {
    init(event.target.querySelector?.('[data-ob-expert]'));
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["orignia-footer-3d"] && !Shopify.designMode) return;
  try {
    
(() => {
  const init = (root) => {
    if (!root || root.dataset.obCurtainFooterReady === 'true') return;
    root.dataset.obCurtainFooterReady = 'true';

    const stage = root.querySelector('[data-ob-letter-stage]');
    const details = [...root.querySelectorAll('[data-ob-curtain-details]')];
    const mobile = window.matchMedia('(max-width: 749px)');
    const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)');

    const syncDetails = () => {
      details.forEach((item) => {
        if (mobile.matches) item.removeAttribute('open');
        else item.setAttribute('open','');
      });
    };

    syncDetails();
    if (typeof mobile.addEventListener === 'function') {
      mobile.addEventListener('change', syncDetails);
    }

    if (!stage || reduceMotion.matches) {
      root.classList.add('is-wordmark-visible');
      return;
    }

    root.classList.add('is-letter-ready');

    const reveal = () => {
      if (root.classList.contains('is-wordmark-visible')) return;
      root.classList.add('is-wordmark-visible');
    };

    if ('IntersectionObserver' in window) {
      const observer = new IntersectionObserver((entries) => {
        const visible = entries.some((entry) => entry.isIntersecting && entry.intersectionRatio >= .24);
        if (!visible) return;
        reveal();
        observer.disconnect();
      }, { threshold:[.24,.4] });
      observer.observe(stage);
    } else {
      window.requestAnimationFrame(reveal);
    }
  };

  document.querySelectorAll('[data-ob-curtain-footer]').forEach(init);
  document.addEventListener('shopify:section:load', (event) => {
    init(event.target.querySelector?.('[data-ob-curtain-footer]'));
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["orignia-gloss-divider"] && !Shopify.designMode) return;
  try {
    
(() => {
  const clamp = (n, min = 0, max = 1) => Math.min(max, Math.max(min, n));
  const smoothstep = (edge0, edge1, value) => {
    const t = clamp((value - edge0) / Math.max(.0001, edge1 - edge0));
    return t * t * (3 - 2 * t);
  };

  const init = (root) => {
    if (!root || root.dataset.obGatewayReady === 'true') return;
    root.dataset.obGatewayReady = 'true';

    const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
    if (reduceMotion.matches) return;

    const wrapper = root.closest('.shopify-section');
    const nextSection = wrapper?.nextElementSibling || null;
    const duration = 2150;
    let raf = 0;
    let started = false;
    let finished = false;
    let userIntervened = false;
    let inputArmed = false;
    let startTime = 0;
    let alignTimer = 0;
    let armTimer = 0;

    const render = (p) => {
      const open = smoothstep(0, .18, p);
      const enter = smoothstep(.10, .42, p);
      const pass = smoothstep(.34, .60, p);
      const deep = smoothstep(.56, .82, p);
      const exit = smoothstep(.86, 1, p);
      const ringFade = smoothstep(.30, .48, p);

      const portal = 14 + open * 142;
      const zoom = 1.02 + enter * .075 + deep * .055;
      const sceneX = -(enter * 2 + deep * 5);
      const sceneY = -(enter * 1.2 + deep * 2.6);
      const characterX = -10 - pass * 34;
      const characterOpacity = .95 * (1 - pass);
      const foregroundX = 8 - enter * 8 - deep * 10;
      const ringScale = .72 + open * .85;
      const ringOpacity = open * (1 - ringFade) * .95;
      const exitTop = 100 - exit * 104;
      const bloomIn = smoothstep(.72, .90, p);
      const bloom = bloomIn * (1 - exit * .45);

      root.style.setProperty('--ob-portal', portal.toFixed(2) + '%');
      root.style.setProperty('--ob-zoom', zoom.toFixed(4));
      root.style.setProperty('--ob-scene-x', sceneX.toFixed(2) + '%');
      root.style.setProperty('--ob-scene-y', sceneY.toFixed(2) + '%');
      root.style.setProperty('--ob-character-x', characterX.toFixed(2) + 'px');
      root.style.setProperty('--ob-character-opacity', characterOpacity.toFixed(3));
      root.style.setProperty('--ob-foreground-x', foregroundX.toFixed(2) + 'px');
      root.style.setProperty('--ob-ring-scale', ringScale.toFixed(3));
      root.style.setProperty('--ob-ring-opacity', ringOpacity.toFixed(3));
      root.style.setProperty('--ob-exit-top', exitTop.toFixed(2) + '%');
      root.style.setProperty('--ob-bloom', bloom.toFixed(3));
    };

    const markIntervention = () => {
      if (inputArmed && started && !finished) userIntervened = true;
    };

    const finish = () => {
      if (finished) return;
      finished = true;
      render(1);
      root.classList.add('is-complete');

      if (!userIntervened && nextSection?.scrollIntoView) {
        window.setTimeout(() => {
          if (!userIntervened) {
            nextSection.scrollIntoView({ behavior:'smooth', block:'start' });
          }
        }, 120);
      }
    };

    const frame = (now) => {
      if (!document.documentElement.contains(root)) {
        cleanup();
        return;
      }
      if (!startTime) startTime = now;
      const p = clamp((now - startTime) / duration);
      render(p);
      if (p < 1) raf = window.requestAnimationFrame(frame);
      else finish();
    };

    const play = () => {
      if (started) return;
      started = true;
      root.classList.add('is-playing');
      armTimer = window.setTimeout(() => { inputArmed = true; }, 320);
      raf = window.requestAnimationFrame(frame);
    };

    const alignAndPlay = () => {
      if (started) return;
      const top = root.getBoundingClientRect().top;
      if (Math.abs(top) > 10) {
        root.scrollIntoView({ behavior:'smooth', block:'start' });
        alignTimer = window.setTimeout(play, 300);
      } else {
        play();
      }
    };

    const observer = new IntersectionObserver((entries) => {
      if (started) return;
      const entry = entries.find((item) => item.isIntersecting);
      if (!entry) return;
      const vh = window.innerHeight || 1;
      if (entry.boundingClientRect.top <= vh * .34) {
        observer.disconnect();
        alignAndPlay();
      }
    }, { threshold:[0,.15,.3,.5,.7], rootMargin:'0px 0px -8% 0px' });

    const cleanup = () => {
      observer.disconnect();
      window.removeEventListener('wheel', markIntervention);
      window.removeEventListener('touchmove', markIntervention);
      window.removeEventListener('pointermove', markIntervention);
      if (raf) window.cancelAnimationFrame(raf);
      if (alignTimer) window.clearTimeout(alignTimer);
      if (armTimer) window.clearTimeout(armTimer);
      root._obGatewayCleanup = null;
    };

    root._obGatewayCleanup = cleanup;
    observer.observe(root);
    window.addEventListener('wheel', markIntervention, { passive:true });
    window.addEventListener('touchmove', markIntervention, { passive:true });
    window.addEventListener('pointermove', markIntervention, { passive:true });
    render(0);
  };

  document.querySelectorAll('[data-ob-world-gateway]').forEach(init);

  document.addEventListener('shopify:section:load', (event) => {
    init(event.target.querySelector?.('[data-ob-world-gateway]'));
  });

  document.addEventListener('shopify:section:unload', (event) => {
    const root = event.target.querySelector?.('[data-ob-world-gateway]');
    root?._obGatewayCleanup?.();
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["orignia-hero"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('orignia-hero')) {
    class OrigniaHero extends HTMLElement {
      connectedCallback() {
        this.slides = [...this.querySelectorAll('[data-slide]')];
        this.dots = [...this.querySelectorAll('[data-go]')];
        this.index = 0;
        this.auto = this.dataset.auto !== 'false';
        this.reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

        this.dots.forEach((dot, i) => dot.addEventListener('click', () => this.show(i)));
        this.querySelector('[data-next]')?.addEventListener('click', () => this.show(this.index + 1));
        this.querySelector('[data-prev]')?.addEventListener('click', () => this.show(this.index - 1));

        this.slides.forEach((slide, i) => {
          const video = slide.querySelector('[data-video]');
          if (!video) return;
          video.muted = true;
          video.defaultMuted = true;
          video.playsInline = true;
          video.addEventListener('ended', () => {
            if (this.auto && !this.reduce && i === this.index) this.show(this.index + 1);
          });
        });

        this.show(0);
      }

      show(value) {
        if (!this.slides.length) return;
        this.index = (value + this.slides.length) % this.slides.length;

        this.slides.forEach((slide, i) => {
          const active = i === this.index;
          const video = slide.querySelector('[data-video]');
          slide.classList.toggle('is-active', active);

          if (!video) return;
          if (!active || this.reduce) {
            video.pause();
            video.preload = 'none';
            if (!active) {
              try { video.currentTime = 0; } catch (e) {}
            }
            return;
          }

          video.preload = i === 0 ? 'auto' : 'metadata';
          try { video.currentTime = 0; } catch (e) {}
          const play = video.play();
          if (play?.catch) play.catch(() => {});
        });

        this.dots.forEach((dot, i) => {
          const active = i === this.index;
          dot.classList.toggle('is-active', active);
          dot.setAttribute('aria-selected', active ? 'true' : 'false');
        });
      }
    }
    customElements.define('orignia-hero', OrigniaHero);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["orignia-home-routine"] && !Shopify.designMode) return;
  try {
    
(() => {
  const init = (root) => {
    if (!root || root.dataset.obRoutineReady === 'true') return;
    root.dataset.obRoutineReady = 'true';

    const tabs = [...root.querySelectorAll('[data-ob-routine-tab]')];
    const panels = [...root.querySelectorAll('[data-ob-routine-panel]')];
    if (!tabs.length || !panels.length) return;

    const activate = (index, focus = false) => {
      tabs.forEach((tab, i) => {
        const active = i === index;
        tab.classList.toggle('is-active', active);
        tab.setAttribute('aria-selected', active ? 'true' : 'false');
        tab.tabIndex = active ? 0 : -1;
        if (active && focus) tab.focus();
      });
      panels.forEach((panel, i) => {
        const active = i === index;
        panel.hidden = !active;
        panel.classList.toggle('is-active', active);
      });
    };

    tabs.forEach((tab, index) => {
      tab.addEventListener('click', () => activate(index));
      tab.addEventListener('keydown', (event) => {
        if (!['ArrowRight','ArrowLeft','ArrowDown','ArrowUp'].includes(event.key)) return;
        event.preventDefault();
        const delta = (event.key === 'ArrowRight' || event.key === 'ArrowDown') ? 1 : -1;
        activate((index + delta + tabs.length) % tabs.length, true);
      });
    });

    activate(0);
  };

  document.querySelectorAll('[data-ob-routine]').forEach(init);
  document.addEventListener('shopify:section:load', (event) => {
    init(event.target.querySelector?.('[data-ob-routine]'));
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["orignia-home-trust"] && !Shopify.designMode) return;
  try {
    
(() => {
  const init = (root) => {
    if (!root || root.dataset.obTrustReady === 'true') return;
    root.dataset.obTrustReady = 'true';

    const finePointer = window.matchMedia('(hover:hover) and (pointer:fine)');
    if (!finePointer.matches) return;

    root.querySelectorAll('[data-ob-trust-card]').forEach((card) => {
      card.addEventListener('pointermove', (event) => {
        const rect = card.getBoundingClientRect();
        card.style.setProperty('--spot-x', (event.clientX - rect.left) + 'px');
        card.style.setProperty('--spot-y', (event.clientY - rect.top) + 'px');
      }, { passive:true });
    });
  };

  document.querySelectorAll('[data-ob-home-trust]').forEach(init);
  document.addEventListener('shopify:section:load', (event) => {
    init(event.target.querySelector?.('[data-ob-home-trust]'));
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["orignia-key-benefits"] && !Shopify.designMode) return;
  try {
    
(() => {
  document.querySelectorAll('[data-ob-benefit-spotlight]').forEach((root) => {
    if (root.dataset.obReady === 'true') return;
    root.dataset.obReady = 'true';

    const stage = root.querySelector('[data-ob-benefit-stage]');
    const visual = root.querySelector('[data-ob-benefit-visual]');
    const callouts = [...root.querySelectorAll('[data-ob-benefit-callout]')];
    const reduced = window.matchMedia('(prefers-reduced-motion: reduce)');
    const fine = window.matchMedia('(hover:hover) and (pointer:fine)');

    if ('IntersectionObserver' in window && !reduced.matches) {
      const observer = new IntersectionObserver((entries) => {
        entries.forEach((entry) => {
          if (!entry.isIntersecting) return;
          callouts.forEach((item, index) => {
            window.setTimeout(() => item.classList.add('is-visible'), index * 150);
          });
          observer.disconnect();
        });
      }, { threshold: .25 });
      observer.observe(root);
    } else {
      callouts.forEach((item) => item.classList.add('is-visible'));
    }

    const reset = () => {
      visual?.style.removeProperty('--ob-rx');
      visual?.style.removeProperty('--ob-ry');
    };

    stage?.addEventListener('pointermove', (event) => {
      if (!visual || reduced.matches || !fine.matches) return;
      const rect = stage.getBoundingClientRect();
      const x = (event.clientX - rect.left) / rect.width - .5;
      const y = (event.clientY - rect.top) / rect.height - .5;
      visual.style.setProperty('--ob-rx', `${(-y * 3.5).toFixed(2)}deg`);
      visual.style.setProperty('--ob-ry', `${(x * 5).toFixed(2)}deg`);
    });
    stage?.addEventListener('pointerleave', reset);
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["orignia-product-coverflow"] && !Shopify.designMode) return;
  try {
    
(() => {
  const positions = {
    0:   { x:'0%',    z:'80px',   ry:'0deg',   scale:'1',    opacity:'1',   blur:'0px' },
    1:   { x:'76%',   z:'-55px',  ry:'-15deg', scale:'.82',  opacity:'.58', blur:'0px' },
    '-1':{ x:'-76%',  z:'-55px',  ry:'15deg',  scale:'.82',  opacity:'.58', blur:'0px' },
    2:   { x:'118%',  z:'-150px', ry:'-22deg', scale:'.68',  opacity:'.14', blur:'1px' },
    '-2':{ x:'-118%', z:'-150px', ry:'22deg',  scale:'.68',  opacity:'.14', blur:'1px' }
  };

  const init = (root) => {
    if (!root || root.dataset.obMinCoverflowReady === 'true') return;
    root.dataset.obMinCoverflowReady = 'true';

    const cards = [...root.querySelectorAll('[data-ob-coverflow-card]')];
    const links = [...root.querySelectorAll('[data-ob-coverflow-link]')];
    const viewport = root.querySelector('[data-ob-coverflow-viewport]');
    const current = root.querySelector('[data-ob-coverflow-current]');
    const prev = root.querySelector('[data-ob-coverflow-prev]');
    const next = root.querySelector('[data-ob-coverflow-next]');

    if (!cards.length) return;

    let active = 0;
    let touchX = null;

    const normalizeOffset = (offset) => {
      const n = cards.length;
      while (offset > n / 2) offset -= n;
      while (offset < -n / 2) offset += n;
      if (offset > 2) return 2;
      if (offset < -2) return -2;
      return offset;
    };

    const resetTilt = (card) => {
      const tilt = card?.querySelector('[data-ob-coverflow-tilt]');
      if (!tilt) return;
      tilt.style.setProperty('--tilt-x','0deg');
      tilt.style.setProperty('--tilt-y','0deg');
    };

    const render = () => {
      cards.forEach((card, index) => {
        const offset = normalizeOffset(index - active);
        const pos = positions[offset] || positions[offset > 0 ? 2 : -2];

        card.dataset.offset = String(offset);
        card.style.setProperty('--x',pos.x);
        card.style.setProperty('--z',pos.z);
        card.style.setProperty('--ry',pos.ry);
        card.style.setProperty('--scale',pos.scale);
        card.style.setProperty('--opacity',pos.opacity);
        card.style.setProperty('--blur',pos.blur);

        const isActive = index === active;
        card.classList.toggle('is-active',isActive);
        if (isActive) card.setAttribute('aria-current','true');
        else card.removeAttribute('aria-current');

        if (links[index]) links[index].tabIndex = isActive ? 0 : -1;
        if (!isActive) resetTilt(card);
      });

      if (current) current.textContent = String(active + 1).padStart(2,'0');
    };

    const go = (index) => {
      active = (index + cards.length) % cards.length;
      render();
    };

    cards.forEach((card,index) => {
      const link = links[index];
      if (link) {
        link.addEventListener('click',(event) => {
          if (index !== active) {
            event.preventDefault();
            go(index);
          }
        });
      }

      const tilt = card.querySelector('[data-ob-coverflow-tilt]');
      if (tilt) {
        tilt.addEventListener('pointermove',(event) => {
          if (index !== active) return;
          if (!window.matchMedia('(hover:hover) and (pointer:fine)').matches) return;
          const rect = tilt.getBoundingClientRect();
          const px = (event.clientX - rect.left) / rect.width - .5;
          const py = (event.clientY - rect.top) / rect.height - .5;
          tilt.style.setProperty('--tilt-y',(px * 5) + 'deg');
          tilt.style.setProperty('--tilt-x',(-py * 5) + 'deg');
        },{passive:true});

        tilt.addEventListener('pointerleave',() => resetTilt(card));
      }
    });

    prev?.addEventListener('click',() => go(active - 1));
    next?.addEventListener('click',() => go(active + 1));

    viewport?.addEventListener('keydown',(event) => {
      if (event.key === 'ArrowRight') {
        event.preventDefault();
        go(active + 1);
      } else if (event.key === 'ArrowLeft') {
        event.preventDefault();
        go(active - 1);
      }
    });

    viewport?.addEventListener('touchstart',(event) => {
      touchX = event.touches?.[0]?.clientX ?? null;
    },{passive:true});

    viewport?.addEventListener('touchend',(event) => {
      if (touchX === null) return;
      const endX = event.changedTouches?.[0]?.clientX ?? touchX;
      const delta = endX - touchX;
      touchX = null;
      if (Math.abs(delta) < 40) return;
      go(active + (delta < 0 ? 1 : -1));
    },{passive:true});

    render();
  };

  document.querySelectorAll('[data-ob-min-coverflow]').forEach(init);
  document.addEventListener('shopify:section:load',(event) => {
    init(event.target.querySelector?.('[data-ob-min-coverflow]'));
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["orignia-product-gallery"] && !Shopify.designMode) return;
  try {
    
(() => {
  const init = (root) => {
    if (!root || root.dataset.obReady === 'true') return;
    root.dataset.obReady = 'true';

    const slides = [...root.querySelectorAll('[data-ob-gallery-slide]')];
    const thumbs = [...root.querySelectorAll('[data-ob-gallery-thumb]')];
    const main = root.querySelector('[data-ob-gallery-main]');
    if (!slides.length) return;

    let active = 0;
    let startX = 0;
    let startY = 0;

    const show = (index) => {
      const next = Math.max(0, Math.min(slides.length - 1, index));
      active = next;
      slides.forEach((slide, i) => slide.classList.toggle('is-active', i === next));
      thumbs.forEach((thumb, i) => thumb.classList.toggle('is-active', i === next));
      thumbs[next]?.scrollIntoView?.({ behavior:'smooth', inline:'center', block:'nearest' });
    };

    thumbs.forEach((thumb, index) => {
      thumb.addEventListener('click', () => show(index));
    });

    main?.addEventListener('touchstart', (event) => {
      const touch = event.touches[0];
      startX = touch.clientX;
      startY = touch.clientY;
    }, { passive:true });

    main?.addEventListener('touchend', (event) => {
      const touch = event.changedTouches[0];
      const dx = touch.clientX - startX;
      const dy = touch.clientY - startY;
      if (Math.abs(dx) < 45 || Math.abs(dx) < Math.abs(dy)) return;
      show(dx < 0 ? (active + 1) % slides.length : (active - 1 + slides.length) % slides.length);
    }, { passive:true });
  };

  document.querySelectorAll('[data-ob-product-gallery]').forEach(init);
  document.addEventListener('shopify:section:load', (event) => {
    init(event.target.querySelector?.('[data-ob-product-gallery]'));
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["orignia-product-hero"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const root = document.querySelector('[data-ob-product-hero]');
    if (!root || root.dataset.obReady === 'true') return;
    root.dataset.obReady = 'true';

    const media = root.querySelector('[data-ob-tilt]');
    const video = root.querySelector('video');
    const reduced = window.matchMedia('(prefers-reduced-motion: reduce)');
    const desktop = window.matchMedia('(hover: hover) and (pointer: fine)');

    const resetTilt = () => {
      media?.style.removeProperty('--ob-rx');
      media?.style.removeProperty('--ob-ry');
    };

    const onPointerMove = (event) => {
      if (!media || reduced.matches || !desktop.matches) return;
      const rect = media.getBoundingClientRect();
      if (!rect.width || !rect.height) return;
      const x = (event.clientX - rect.left) / rect.width - .5;
      const y = (event.clientY - rect.top) / rect.height - .5;
      media.style.setProperty('--ob-rx', `${(-y * 3.2).toFixed(2)}deg`);
      media.style.setProperty('--ob-ry', `${(x * 4.2).toFixed(2)}deg`);
    };

    const syncVideo = () => {
      if (!video) return;
      if (reduced.matches) {
        video.pause();
        resetTilt();
        return;
      }
      video.muted = true;
      video.play().catch(() => {});
    };

    media?.addEventListener('pointermove', onPointerMove);
    media?.addEventListener('pointerleave', resetTilt);
    media?.addEventListener('pointercancel', resetTilt);
    video?.addEventListener('loadedmetadata', syncVideo);
    reduced.addEventListener?.('change', syncVideo);
    desktop.addEventListener?.('change', resetTilt);

    syncVideo();

    const cta = root.querySelector('[data-ob-product-cta]');
    cta?.addEventListener('click', (event) => {
      const href = cta.getAttribute('href');
      const target = href === '#Orignia3D'
        ? document.querySelector('#Orignia3D')
        : document.querySelector('[id^="MainProduct-"]');
      if (!target) return;
      event.preventDefault();
      target.scrollIntoView({ behavior: reduced.matches ? 'auto' : 'smooth', block: 'start' });
    });

    const depthCopy = root.querySelector('[data-ob-3d-copy]');
    if (depthCopy && !reduced.matches) {
      let ticking = false;
      const syncDepth = () => {
        const rect = depthCopy.getBoundingClientRect();
        const viewport = window.innerHeight || 1;
        const progress = Math.max(-1, Math.min(1, (rect.top + rect.height / 2 - viewport / 2) / viewport));
        depthCopy.style.setProperty('--ob-title-shift', `${(-progress * 7).toFixed(1)}px`);
        ticking = false;
      };
      window.addEventListener('scroll', () => {
        if (ticking) return;
        ticking = true;
        window.requestAnimationFrame(syncDepth);
      }, { passive:true });
      syncDepth();
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["orignia-product-orbit"] && !Shopify.designMode) return;
  try {
    
(() => {
  const positions = {
    0:  { x:'0%',    y:'0rem', z:'100px',  ry:'0deg',   scale:'1',    opacity:'1' },
    1:  { x:'72%',   y:'1rem', z:'-80px',  ry:'-24deg', scale:'.82',  opacity:'.72' },
    2:  { x:'112%',  y:'2rem', z:'-190px', ry:'-36deg', scale:'.68',  opacity:'.28' },
    '-1':{ x:'-72%',  y:'1rem', z:'-80px',  ry:'24deg',  scale:'.82',  opacity:'.72' },
    '-2':{ x:'-112%', y:'2rem', z:'-190px', ry:'36deg',  scale:'.68',  opacity:'.28' }
  };

  const init = (root) => {
    if (!root || root.dataset.obOrbitReady === 'true') return;
    root.dataset.obOrbitReady = 'true';

    const cards = [...root.querySelectorAll('[data-ob-orbit-card]')];
    const links = [...root.querySelectorAll('[data-ob-orbit-link]')];
    const dots = [...root.querySelectorAll('[data-ob-orbit-dot]')];
    const prev = root.querySelector('[data-ob-orbit-prev]');
    const next = root.querySelector('[data-ob-orbit-next]');
    const scene = root.querySelector('[data-ob-orbit-scene]');

    if (!cards.length) return;

    let active = 0;
    let touchStartX = null;

    const normalizeDelta = (delta) => {
      const n = cards.length;
      if (n <= 1) return 0;
      while (delta > n / 2) delta -= n;
      while (delta < -n / 2) delta += n;
      if (delta > 2) return 2;
      if (delta < -2) return -2;
      return delta;
    };

    const render = () => {
      cards.forEach((card, index) => {
        const offset = normalizeDelta(index - active);
        const pos = positions[offset] || positions[offset > 0 ? 2 : -2];

        card.dataset.offset = String(offset);
        card.style.setProperty('--ob-x', pos.x);
        card.style.setProperty('--ob-y', pos.y);
        card.style.setProperty('--ob-z', pos.z);
        card.style.setProperty('--ob-ry', pos.ry);
        card.style.setProperty('--ob-scale', pos.scale);
        card.style.setProperty('--ob-opacity', pos.opacity);

        const isActive = index === active;
        card.classList.toggle('is-active', isActive);
        if (isActive) card.setAttribute('aria-current','true');
        else card.removeAttribute('aria-current');

        const link = links[index];
        if (link) link.tabIndex = isActive ? 0 : -1;
      });

      dots.forEach((dot, index) => {
        const isActive = index === active;
        dot.classList.toggle('is-active', isActive);
        dot.setAttribute('aria-selected', isActive ? 'true' : 'false');
      });
    };

    const go = (index) => {
      active = (index + cards.length) % cards.length;
      render();
    };

    cards.forEach((card, index) => {
      const link = links[index];
      if (!link) return;

      link.addEventListener('click', (event) => {
        if (index !== active) {
          event.preventDefault();
          go(index);
        }
      });
    });

    dots.forEach((dot, index) => dot.addEventListener('click', () => go(index)));
    prev?.addEventListener('click', () => go(active - 1));
    next?.addEventListener('click', () => go(active + 1));

    root.addEventListener('keydown', (event) => {
      if (event.key === 'ArrowRight') {
        event.preventDefault();
        go(active + 1);
      } else if (event.key === 'ArrowLeft') {
        event.preventDefault();
        go(active - 1);
      }
    });

    scene?.addEventListener('touchstart', (event) => {
      touchStartX = event.touches?.[0]?.clientX ?? null;
    }, { passive:true });

    scene?.addEventListener('touchend', (event) => {
      if (touchStartX === null) return;
      const endX = event.changedTouches?.[0]?.clientX ?? touchStartX;
      const delta = endX - touchStartX;
      touchStartX = null;

      if (Math.abs(delta) < 42) return;
      if (delta < 0) go(active + 1);
      else go(active - 1);
    }, { passive:true });

    render();
  };

  document.querySelectorAll('[data-ob-product-orbit]').forEach(init);
  document.addEventListener('shopify:section:load', (event) => {
    init(event.target.querySelector?.('[data-ob-product-orbit]'));
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["orignia-product-showcase"] && !Shopify.designMode) return;
  try {
    
(() => {
  document.querySelectorAll('[data-ob-product-info]').forEach((root) => {
    if (root.dataset.obReady === 'true') return;
    root.dataset.obReady = 'true';

    const items = [...root.querySelectorAll('[data-ob-micro]')];
    if (!items.length) return;

    let userInteracted = false;

    const openOnly = (target) => {
      items.forEach((item) => {
        if (item === target) item.setAttribute('open','');
        else item.removeAttribute('open');
      });
    };

    items.forEach((details) => {
      const summary = details.querySelector('summary');
      summary?.addEventListener('pointerdown', () => {
        userInteracted = true;
        root.classList.add('is-interacted');
      }, { passive:true });

      details.addEventListener('toggle', () => {
        if (!details.open) return;
        items.forEach((other) => {
          if (other !== details) other.removeAttribute('open');
        });
      });
    });

    const first = items[0];
    if ('IntersectionObserver' in window) {
      const observer = new IntersectionObserver((entries) => {
        entries.forEach((entry) => {
          if (!entry.isIntersecting || entry.intersectionRatio < .42) return;
          if (!userInteracted && first) openOnly(first);
          observer.disconnect();
        });
      }, { threshold:[.42] });
      observer.observe(root);
    } else if (first) {
      openOnly(first);
    }
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["orignia-video-gallery"] && !Shopify.designMode) return;
  try {
    
(() => {
  const init = (root) => {
    if (!root || root.dataset.obReady === 'true') return;
    root.dataset.obReady = 'true';

    const cards = [...root.querySelectorAll('[data-ob-video-card]')];

    cards.forEach((card) => {
      const video = card.querySelector('video');
      const play = card.querySelector('[data-ob-video-play]');
      if (!video || !play) return;

      const stopOthers = () => {
        cards.forEach((other) => {
          if (other === card) return;
          const otherVideo = other.querySelector('video');
          if (!otherVideo) return;
          otherVideo.pause();
          other.classList.remove('is-playing');
        });
      };

      play.addEventListener('click', () => {
        stopOthers();
        video.play().then(() => card.classList.add('is-playing')).catch(() => {});
      });

      video.addEventListener('click', () => {
        if (video.paused) {
          stopOthers();
          video.play().then(() => card.classList.add('is-playing')).catch(() => {});
        } else {
          video.pause();
          card.classList.remove('is-playing');
        }
      });

      video.addEventListener('ended', () => {
        card.classList.remove('is-playing');
      });

      video.addEventListener('pause', () => {
        card.classList.remove('is-playing');
      });
    });

    const track = root.querySelector('[data-ob-video-track]');
    const dots = [...root.querySelectorAll('.ob-video-gallery__dot')];
    if (!track || dots.length < 2) return;

    let ticking = false;
    const syncDots = () => {
      const trackRect = track.getBoundingClientRect();
      const center = trackRect.left + trackRect.width / 2;
      let bestIndex = 0;
      let bestDistance = Infinity;

      [...track.children].forEach((card, index) => {
        const rect = card.getBoundingClientRect();
        const cardCenter = rect.left + rect.width / 2;
        const distance = Math.abs(cardCenter - center);
        if (distance < bestDistance) {
          bestDistance = distance;
          bestIndex = index;
        }
      });

      dots.forEach((dot, index) => dot.classList.toggle('is-active', index === bestIndex));
      ticking = false;
    };

    track.addEventListener('scroll', () => {
      if (ticking) return;
      ticking = true;
      requestAnimationFrame(syncDots);
    }, { passive:true });
  };

  document.querySelectorAll('[data-ob-video-gallery]').forEach(init);
  document.addEventListener('shopify:section:load', (event) => {
    init(event.target.querySelector?.('[data-ob-video-gallery]'));
  });
})();

  } catch(e) { console.error(e); }
})();
})();
